/* istanbul ignore file */ import { createStaticApp } from '@ori-appshell/rendering';
import '@ori/top-area/src/App.css';
import { APP_NAME, EMOTION_CACHE_KEY } from '../constants';
export default createStaticApp({
    emotionCacheKey: EMOTION_CACHE_KEY,
    appName: APP_NAME
});
